<script>
import {defineComponent} from 'vue';
import {pathEscapeSegments} from '../utils/url.ts';

/**
 * @typedef {{ file_path: string, detail: string }} RawWarning
 */

class Warning {
  /**
   * @param {string} filePath
   * @param {string} detail
   */
  constructor(filePath, detail) {
    /** @type {string} */
    this.filePath = pathEscapeSegments(filePath);
    /** @type {string} */
    this.detail = detail; // this will be sanitized by the template
  }
}

export default defineComponent({
  name: 'WarningMessages',
  props: {
    syncWarnings: {
      type: [Array, null, undefined],
      required: false,
      default: null,
    },
    repoLink: {
      type: String,
      required: true,
    },
    branchName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      /** @type {Array<Warning>} */
      warnings: this.syncWarnings ? this.syncWarnings.map((w) => {
        return new Warning(w.file_path, w.detail);
      }) : [],
    };
  },

  methods: {
    /**
     * Dynamically add warnings
     * @param {Array<RawWarning>} warnings
     */
    addWarnings(warnings) {
      for (const w of warnings) {
        this.warnings.push(new Warning(w.file_path, w.detail));
      }
    },

    /**
     * Reset warnings to initial state, and add new ones.
     * @param {Array<RawWarning>} warnings
     */
    replaceWarnings(warnings) {
      this.warnings = this.syncWarnings ? this.syncWarnings.map((w) => {
        return new Warning(w.file_path, w.detail);
      }) : [];
      this.addWarnings(warnings);
    },
  },
});

</script>

<template>
  <div class="warning-messages">
    <div v-for="warning in warnings" :key="warning.file_path" class="ui warning message">
      <a v-if="warning.filePath" :href="repoLink +'/src/' + branchName + '/' + warning.filePath">{{ warning.filePath }}: </a>{{ warning.detail }}
    </div>
  </div>
</template>
